import React from 'react';
import { v4 as uuid } from 'uuid';

// style
import './style.scss';

export default function Experience() {
  const workExp = [
    {
      workplace: 'Electronic Source BD',
      worktimeline: '2020-Present',
      desc: 'Web Administrator',
      id: uuid(),
    },
    {
      workplace: 'Favign',
      worktimeline: '2019-2020',
      desc: 'Chief Web Officer',
      id: uuid(),
    },
    {
      workplace: 'More to gain',
      id: uuid(),
    },
  ];

  return (
    <div id="work">
      <div className="work-left">
        <div className="work-title">Work Experience</div>
      </div>
      <div className="work-right">
        {workExp.map((exp) => (
          <div className="work" key={exp.id}>
            <p className="workplace">
              <i className="fas fa-circle"></i>
              <span>{exp.workplace}</span>
              <span className="work-timeline">
                {exp.worktimeline && `(${exp.worktimeline})`}
              </span>
            </p>
            <p className="work-desc">{exp.desc && exp.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
